<template>
	<div class="d-flex justify-space-between">
		<div class="d-flex flex-column justify-center">
			<div>
				<span class="text-neutral-900 text-body-m">
					{{ $t('web.contact_modal.form.total_travelers.label') }}
				</span>
				<span class="text-error-500">*</span>
			</div>
		</div>
		<ButtonCounter v-model="count" :min="1" />
	</div>
</template>

<script setup lang="ts">
	const count = defineModel<number>()
</script>

<style scoped></style>
